import axios from "axios";
import { getToken, removeToken } from "./auth";
import { version } from "../../package.json";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.timeout = 300000;

export const httpRequest = axios.create();

httpRequest.interceptors.request.use(
	async (config) => {
		if (config.headers === undefined) {
			console.log("headers are undefined");
			return config;
		}
		config.headers["Content-Type"] = "application/json";
		config.headers["x-client-id"] = "cms-8f17bdb1-2acb-49b3-a022-b06fe228ec6e";
		config.headers["x-client-version"] = version;
		const token = getToken();
		if (token != null) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		console.error("httpRequest: Error interceptor request:::", error.response);
		return Promise.reject(error);
	}
);

httpRequest.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error && error.response) {
			if (error.response.status === 403 || error.response.data.code === "err_unauthorized") {
				removeToken();
				window.location.href = "/";
			}
			console.error("httpRequest: Error interceptor response:::", error.response);
			return Promise.reject(error.response);
		} else if (error && error.message !== "canceled") {
			console.error(error);
		} else if (!error) {
			console.error("httpRequest: Error interceptor response::: error is undefined");
		}
	}
);
